module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/captures/captures-list/captures-list.component.sass
// module id = ./src/app/captures/captures-list/captures-list.component.sass
// module chunks = main